module.exports = __webpack_public_path__ + "static/media/covered_layout.1d7c6ad8.svg";